import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LowLevelApi } from '@app/shared/services/state/low-level-api.service';

@Component({
  selector:        'app-spinner',
  templateUrl:     './spinner.component.html',
  styleUrls:       ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:      true,
  imports:         [
    NgIf,
    MatProgressSpinner
  ]
})
export class SpinnerComponent {
  private llapi = inject(LowLevelApi);
  spinner = this.llapi.getSignal('layout.spinner');
}
